export function scrollTo(item, speed) {
	let item_offset = 0;
	let clicked_item = $('[href="' + item + '"]');
	let header_offset = $('.header-wrap').css('position') == 'sticky' || $('.header-wrap').css('position') == 'fixed' ? parseInt($('.header-wrap').css('height')) : 0;
	if(speed === undefined){
		speed = 750;
	}
	if($(item).length > 0){
		item_offset = $(item).offset() !== null ? $(item).offset().top : 0;
		if(item_offset >= 0){
			$('html,body').animate({scrollTop: $(item).offset().top - header_offset}, speed);
		}
		if(clicked_item.length){
			if(item.substring(0, 1) === '#'){
				window.location.hash = item;
				window.scrollTo(item_offset - header_offset, 0);
			}else{
				window.history.pushState(null,clicked_item.attr('title'),clicked_item.attr('href'));
			}
		}
	}
}
